import { Divider } from '@/shared'
import { type ITransferServiceDto, type IChildServiceDec, type IServiceDec } from '@App/types/servicesTypes'

import { Buttons } from './Buttons/Buttons'
import { CategoriesForChose } from './CategoriesForChose/CategoriesForChose'
import { SectionsForChose } from './SectionsForChose/SectionsForChose'
import style from './ServiceTransfer.module.scss'

interface IProps {
    sections: IServiceDec[]
    tranferredService: IChildServiceDec
    onTransferService: (dto: ITransferServiceDto) => void
    category: IServiceDec | null
    setCategory: (category: IServiceDec | null) => void
    chosen: IServiceDec | null
    setChosen: (chosen: IServiceDec | null) => void
}

export const ServiceTransfer = (props: IProps) => {
    const { sections, tranferredService, onTransferService, chosen, setChosen, category, setCategory } = props

    return (
        <div className={style.container}>
            <div className={style.header}>
                <span>Укажите раздел в который будет перенесена услуга</span>
            </div>
            <div className={style.divider}>
                <Divider />
            </div>
            <CategoriesForChose
                sections={sections}
                category={category}
                setCategory={setCategory}
                setChosen={setChosen}
            />
            {category && (
                <>
                    <div className={style.divider}>
                        <Divider />
                    </div>
                    <SectionsForChose
                        category={category}
                        tranferredService={tranferredService}
                        chosen={chosen}
                        setChosen={setChosen}
                    />
                </>
            )}
            {category && chosen && (
                <>
                    <div className={style.serviceSections}>
                        <Divider />
                    </div>
                    <Buttons
                        tranferredService={tranferredService}
                        chosen={chosen}
                        onTransferService={onTransferService}
                    />
                </>
            )}
        </div>
    )
}
